/* Oasis cart housekeeper.
 *
 * Was an inline render-blocking script in <head> that fired fetch /cart.js
 * synchronously on most page loads, then optionally fetch /cart/clear.js
 * + a forced full reload via window.location.href. That tanked LCP/INP/CLS.
 *
 * This module is loaded with `defer` so it never blocks the parser, runs
 * after DOMContentLoaded, and self-disables on routes that should never
 * touch the cart (product, cart, checkout, /pages/quiz, /pages/p10*,
 * /pages/blueprint*, /pages/newislanddesign*, /pages/thank-you*, /pages/rum-point*).
 *
 * Set window.OasisCartHousekeeper = { disable: true } before this loads
 * to short-circuit (e.g. for QA / debug).
 */
(function () {
  'use strict';

  if (window.OasisCartHousekeeper && window.OasisCartHousekeeper.disable) return;

  var pageType = (window.Shopify && window.Shopify.pageType) || document.documentElement.getAttribute('data-page-type') || '';
  if (pageType === 'product' || pageType === 'cart') return;

  // Don't clear on landing/funnel routes that drive the reserve-to-checkout flow.
  var path = window.location.pathname || '';
  var skipPathPatterns = [
    /^\/cart/i,
    /^\/checkouts?(\/|$)/i,
    /^\/products\//i,
    /^\/pages\/quiz/i,
    /^\/pages\/p10/i,
    /^\/pages\/blueprint/i,
    /^\/pages\/newislanddesign/i,
    /^\/pages\/thank-you/i,
    /^\/pages\/thankyou/i,
    /^\/pages\/rum-point/i
  ];
  for (var i = 0; i < skipPathPatterns.length; i++) {
    if (skipPathPatterns[i].test(path)) return;
  }

  var FLAG = 'oasis_session_cart_cleared';
  var QUERY_KEY = 'cart_cleared';

  function safeStorageGet(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function safeStorageSet(key, val) { try { sessionStorage.setItem(key, val); return true; } catch (e) { return false; } }
  function safeStorageRemove(key) { try { sessionStorage.removeItem(key); } catch (e) {} }

  // If the page just reloaded from a clear, scrub the query param without another reload.
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get(QUERY_KEY) === '1') {
    urlParams.delete(QUERY_KEY);
    var search = urlParams.toString();
    var newUrl = window.location.pathname + (search ? '?' + search : '') + window.location.hash;
    if (newUrl !== window.location.pathname + window.location.search + window.location.hash) {
      try { window.history.replaceState({}, '', newUrl); } catch (e) {}
    }
    return;
  }

  if (safeStorageGet(FLAG)) return;

  // Defer the actual cart check to idle time so it never fights with LCP.
  var run = function () {
    fetch('/cart.js', { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart fetch ' + r.status); return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          safeStorageSet(FLAG, '1');
          return;
        }
        if (!safeStorageSet(FLAG, '1')) return; // bail if storage is unavailable to avoid reload loops
        return fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('cart clear ' + r.status);
            // Reload exactly once, marked so the param can be scrubbed on the way back.
            var reloadParams = new URLSearchParams(window.location.search);
            reloadParams.set(QUERY_KEY, '1');
            var reloadUrl = window.location.pathname + '?' + reloadParams.toString() + window.location.hash;
            window.location.href = reloadUrl;
          });
      })
      .catch(function (err) {
        // On any error, remove the flag so a retry is possible later in the session.
        safeStorageRemove(FLAG);
        if (window.console && console.warn) console.warn('[oasis-cart-housekeeper]', err && err.message ? err.message : err);
      });
  };

  // Listen for add-to-cart submits so we know the user has just intentionally added something
  // and we should NOT clear during this session.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').trim();
    if (!action) return;
    var normalized = action.replace(/^https?:\/\/[^/]+/i, '');
    var addUrl = (window.OasisRoutes && window.OasisRoutes.cartAddUrl) || '/cart/add';
    if (normalized === addUrl || normalized === addUrl + '.js') {
      safeStorageSet(FLAG, '1');
    }
  }, true);

  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 2000 });
  } else {
    setTimeout(run, 250);
  }
})();
